import { React, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

// Note Text Area //
export default function ProgramNoteTextArea(props) {
  const { isEdit, value, setValue, placeholder } = props;

  const [isFirst, setIsFirst] = useState(true);

  const TextRef = useRef(null);

  useEffect(() => {
    if (isFirst) {
      TextRef.current.style.height = '100px';
      
      setTimeout(() => {
        setIsFirst(false);
      }, 100)
    }
    else {
      TextRef.current.style.height = 'auto';
      TextRef.current.style.height = TextRef.current.scrollHeight + 'px';
    }
  }, [value, isFirst])

  function handleChange(e) {
    setValue(e.target.value);
  }

  return (
    <Input
      ref={TextRef}
      disabled={!isEdit}
      type='text'
      value={value}
      placeholder={placeholder}
      onChange={handleChange}/>
  )
};

const Input = styled.textarea`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin: 8px 10px 10px 10px;
  // width: 92.02%;
  width: calc(100% - 22px);
  min-height: 100px;
  max-height: auto;

  resize: none;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  border: 0px solid #DFDFDF;
  background-color: transparent;

  color: #FFFFFF;

	outline: none;

	::placeholder {
		color: #F2F2F2;
	}
`;